var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading flex-center"},[_c('fingerprint-spinner',{attrs:{"animation-duration":1500,"size":100,"color":"#df1818"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }